import { Roles } from "src/@types/users";

export enum AuthStatus {
  AUTHORIZED = "authorized",
  UNAUTHORIZED = "unauthorized",
}

export const ONLY_FOR = {
  ...Roles,
  ...AuthStatus,
} as const;

export type OnlyFor = Roles | AuthStatus;
